webpackJsonp([170264817138936],{

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(413);
	
	var _Layout = __webpack_require__(23);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Press = function Press(_ref) {
	  var locale = _ref.pathContext.locale;
	  return _react2.default.createElement(
	    _Layout2.default,
	    { locale: locale },
	    _react2.default.createElement(
	      'div',
	      { className: 'press row no-gutters' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-12 col-lg-6 articles' },
	        _react2.default.createElement(
	          'h5',
	          { className: 'akkurat mb-4' },
	          'Des gens qui disent du bien de nous :)'
	        ),
	        _react2.default.createElement(
	          'h6',
	          { className: 'courier-new' },
	          _react2.default.createElement(
	            'u',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.doitinparis.com/fr/bons-rouleaux-de-printemps-paris-24394',
	                target: '_blank'
	              },
	              'DO IT IN PARIS \u2013 2019'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          'C\u2019est une affaire qui roule. Le comptoir monomaniaque du 11e mont\xE9 en 2016 par la ravissante My-Ly Pham d\xE9livre les meilleurs spring rolls de Paris toutes cat\xE9gories. Son credo ? Une fabrication \xE0 la vietnamienne dans les r\xE8gles de l\u2019art sur une base de vermicelles de riz dans une atmosph\xE8re chill.',
	          _react2.default.createElement(
	            'p',
	            { className: 'mt-2' },
	            'Au total, 7 recettes plus all\xE9chantes les unes que les autres : porc \xE0 la citronnelle, carottes, pickles, concombre, cacahu\xE8tes ; omelette \xE0 la japonaise, avocat, oignons caram\xE9lis\xE9es ; saumon fum\xE9, fromage frais. \xC0 dipper dans d\u2019irr\xE9sistibles sauces maison.'
	          )
	        ),
	        _react2.default.createElement(
	          'h6',
	          { className: 'courier-new' },
	          _react2.default.createElement(
	            'u',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.anousparis.fr/a-manger/la-tendance-est-aux-rouleaux-de-printemps-a-paris/?fbclid=IwAR2zc3beaSjuVrRTWgdt3enuF-0Ypof9NsApt-sSlvVhE3UJPv80QY3Uut0',
	                target: '_blank'
	              },
	              'A NOUS PARIS \u2013 2019'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          'Avec ce lot de nouvelles adresses, on en oublierait presque l\u2019origine de ces galettes de riz garnies. Eh oui, car m\xEAme s\u2019il fait un retour en force dans la capitale, le rouleau de printemps reste n\xE9anmoins un grand classique de la gastronomie vietnamienne. D\u2019ailleurs, My Ly est l\xE0 pour nous le rappeler dans son adorable cantoche de poche. Avec de g\xE9n\xE9reux rouleaux coup\xE9s en deux dans des paniers en bambou tradi, votre repas risque de vous faire voyager en terre lointaine. Et encore, c\u2019est sans compter sur les assiettes d\xE9pareill\xE9es en porcelaine asiatique d\u2019une mignonnerie absolue. Quand au caf\xE9 viet \u2013 avec ou sans sa larme de lait concentr\xE9 sucr\xE9 \u2013 au go\xFBt beurr\xE9, on en emporterait bien quelques litrons tellement il est bon.'
	        ),
	        _react2.default.createElement(
	          'h6',
	          { className: 'courier-new' },
	          _react2.default.createElement(
	            'u',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.vogue.fr/lifestyle/article/les-meilleurs-restaurants-vietnamiens-a-paris?fbclid=IwAR0ECqXda19URWa8GgnO2kS1nBe-TUjYHavYyo-CCd_69BpcLe-8WrokxCo',
	                target: '_blank'
	              },
	              'VOGUE \u2013 2019'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          'Chez Banoi, jolie table de la rue Amelot men\xE9e par la cheffe My-Ly, le rouleau de printemps est la star de la carte. Et pour cause, il est d\xE9clin\xE9 selon des saveurs peu communes comme le m\xE9lange de crevettes, mangue, carottes et pickles ou encore le porc-citronnelle bourr\xE9 de carottes, concombres et cacahu\xE8tes. Une id\xE9e diff\xE9rente du rouleau de printemps.'
	        ),
	        _react2.default.createElement(
	          'h6',
	          { className: 'courier-new' },
	          'LE PARISIEN \u2013 2019'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          '\xAB Comptoir en bois et petits pots de plantes grasses, le Banoi est une parenth\xE8se zen au c\u0153ur de la ville. Dodus et savoureux, les rouleaux de printemps (3,50\u20AC \xE0 la carte) sont la sp\xE9cialit\xE9 de la maison \xBB'
	        ),
	        _react2.default.createElement(
	          'h6',
	          { className: 'courier-new' },
	          _react2.default.createElement(
	            'u',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://fr.gaultmillau.com/restaurant/banoi-restaurant', target: '_blank' },
	              'GAULT ET MILLAU \u2013 2018'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          'Nich\xE9s dans une feuille de riz translucide, les vermicelles et les herbes fra\xEEches s\'enrobent de porc \xE0 la citronnelle acidul\xE9 \xE0 la carotte pickles ou de saumon teriyaki au gingembre grill\xE9... Les gentils rouleaux de Banoi s\'avalent en triplet plong\xE9s dans une soyeuse mayonnaise au s\xE9same ou une sauce cacahu\xE8tes. Un gentil d\xE9jeuner vietnamien pour un peu moins de dix euros, juste ce qu\'il faut pour se permettre un caf\xE9 autochtone - respectueusement sucrable au lait concentr\xE9 - et boulotter un dessert qui embobine les fuseaux : chiffon-cake au pandan cotonneux ou g\xE9noise repli\xE9e autour d\'une cr\xE8me au s\xE9same noir. Un peu \xE0 bout dans les gargotes parisiennes, voil\xE0 le rouleau de printemps ragaillardi par des recettes rondement bien roul\xE9es !'
	        ),
	        _react2.default.createElement(
	          'h6',
	          { className: 'courier-new' },
	          'FRAGONARD 2018'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          'Restaurant intimiste et sympathique, Banoi revisite le rouleau de printemps vietnamien. Au milieu d\u2019une belle d\xE9coration au bois claire, rappelant celle des restaurants du pays, la cheffe My-Ly PHAM propose une carte aux d\xE9clinaisons originales. Venez d\xE9couvrir un gourmant rouleau saumon-teriyaki ou un surprenant rouleau crevette-mangue, surmont\xE9 de d\xE9licieux pickles et d\u2019oignons. En accompagnement, les sauces nuoc-m\xE2m, peanuts et mayo-s\xE9same sont un vrai d\xE9lice.'
	        ),
	        _react2.default.createElement(
	          'h6',
	          { className: 'courier-new' },
	          _react2.default.createElement(
	            'u',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.telerama.fr/sortir/les-40-femmes-qui-agitent-la-gastronomie-parisienne,154973.php',
	                target: '_blank'
	              },
	              'TELERAMA - Les 70 femmes qui agitent la gastronomie parisienne - 2017'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          '\xAB Certes, une hirondelle ne fait pas le printemps... mais un rouleau peut nous en rapprocher ! Sp\xE9cialit\xE9 de cette mignonne cantine vietnamienne situ\xE9e \xE0 deux pas du Cirque d\'Hiver, le rouleau de printemps se plie \xE0 toutes les fantaisies de My Ly Pham. M\xEAl\xE9s aux vermicelles de riz, lamelles de porc confit, tofu caram\xE9lis\xE9, mangue, avocat, saumon marin\xE9 ou oignons frits offrent des variations bien temp\xE9r\xE9es au goi cuon. \xBB'
	        ),
	        _react2.default.createElement(
	          'h6',
	          { className: 'courier-new' },
	          _react2.default.createElement(
	            'u',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.facebook.com/watch/?v=1495612030491064', target: '_blank' },
	              'TRES TRES BON \u2013 2017'
	            )
	          )
	        ),
	        _react2.default.createElement('p', { className: 'courier-new text' }),
	        _react2.default.createElement(
	          'h6',
	          { className: 'courier-new' },
	          _react2.default.createElement(
	            'u',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.madmoizelle.com/portrait-my-ly-restaurant-banoi-701583',
	                target: '_blank'
	              },
	              'MADMOIZELLE \u2013 2017'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'courier-new text' },
	          '\xAB Monter sa bo\xEEte quand on est jeune, c\'est possible. Exemple avec My-Ly, passionn\xE9e de cuisine vietnamienne, qui a lanc\xE9 son restaurant \xE0 26 ans. \xBB'
	        )
	      ),
	      _react2.default.createElement('div', { className: 'col-12 col-lg-6' })
	    )
	  );
	};
	
	exports.default = Press;
	module.exports = exports['default'];

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-press-js-fb7e8232739744d49ca7.js